<script lang="ts">
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import { VueImageZoomer } from 'vue-image-zoomer';
import 'vue-image-zoomer/dist/style.css';

type Props = {
  alt?: string;
  id?: string;
  src: string;
  zoomSrc?: string;
  scale?: number;
};
</script>

<script setup lang="ts">
defineProps<Props>();

const searchIcon = "<span class='material-symbols-outlined Icon__size-large'>search</span>";
</script>

<template>
  <div :class="$style.container">
    <VueImageZoomer
      :id="id"
      :alt="alt"
      :hover-message="searchIcon"
      loading="eager"
      :regular="src"
      :touch-message="searchIcon"
      :zoom="zoomSrc"
      :zoom-amount="scale ?? 3"
    />
  </div>
</template>

<style module lang="scss" src="./ImageMagnifier.scss" />
